(() => {
  const modal = document.getElementById('blogImageModal');
  const modalImg = document.getElementById('blogImageModalImg');
  const closeBtn = document.querySelector('.blog-img-modal__close');
  if (!modal || !modalImg) return;

  // Contenedores válidos del blog/artículo en Dawn
  const BLOG_CONTAINERS = [
    '.main-blog',           // listado de artículos (tu sección)
    '.blog-articles',       // wrapper de cards
    '.article-template',    // página de artículo
    '.rte'                  // contenido del artículo
  ];

  const isInBlogArea = (el) => BLOG_CONTAINERS.some(sel => el.closest(sel));

  // Delegación: captura clics en cualquier <img> dentro del blog/artículo
  document.addEventListener('click', (e) => {
    const img = e.target.closest('img');
    if (!img) return;
    if (!isInBlogArea(img)) return;

    // evita que un <a> envuelva la imagen y navegue
    const link = img.closest('a');
    if (link) e.preventDefault();
    e.stopPropagation();

    modalImg.src = img.currentSrc || img.src || '';
    modalImg.alt = img.alt || '';
    if (modal.showModal) modal.showModal();
    else modal.setAttribute('open', 'true');
  }, true); // capture=true para interceptar antes que el <a>

  const close = () => (modal.close ? modal.close() : modal.removeAttribute('open'));
  closeBtn?.addEventListener('click', close);
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();
